/**
 * Types aligned with VideoGen API: Prompt to video
 * @see https://docs.videogen.io/api-15915875
 */

export type AspectRatioId = "portrait" | "landscape" | "square";

/** Aspect ratio for API (width, height) */
export interface AspectRatio {
  width: number;
  height: number;
}

export const ASPECT_RATIOS: Record<AspectRatioId, AspectRatio> = {
  portrait: { width: 9, height: 16 },
  landscape: { width: 16, height: 9 },
  square: { width: 1, height: 1 },
};

/** Request body for POST /v2/prompt-to-video */
export interface PromptToVideoRequest {
  prompt: string;
  targetScriptWordCount?: number;
  outputLanguageCode?: string;
  websiteUrls?: string[];
  useGetty?: boolean;
  useGenerativeImage?: boolean;
  imageGenStyle?: string;
  voice?: string;
  voiceVolume?: number;
  musicUrl?: string;
  musicVolume?: number;
  captionDetails?: CaptionDetails;
  aspectRatio: AspectRatio;
  minDimensionPixels?: number;
  webhookUrl?: string;
}

export interface CaptionDetails {
  captionFontName?: string;
  captionFontWeight?: number;
  captionFontSize?: number;
  captionTextJustification?: "LEFT" | "CENTER" | "RIGHT";
  captionVerticalAlignment?: "TOP" | "MIDDLE" | "BOTTOM";
  captionIsHidden?: boolean;
}

/** Response from prompt-to-video */
export interface PromptToVideoResponse {
  apiFileId: string;
}

/** Media source selection in UI */
export type MediaSourceId = "stock" | "aiImage" | "istock" | "custom";

/** Workflow type */
export type WorkflowId =
  | "ideaToVideo"
  | "scriptToVideo"
  | "voiceoverToVideo"
  | "record"
  | "uploadEdit"
  | "aiClip"
  | "editor"
  | "feedback";
